
import { useNavigate } from 'react-router-dom';

interface ProductCardProps {
  id: number;
  name: string;
  price: string;
  category: string;
  image: string;
  description: string;
  sizes: string[];
  colors: string[];
  material: string;
  care: string;
  isNew: boolean;
  isRecommended: boolean;
  quickViewImage?: string; // 追加
}

export default function ProductCard({
  id,
  name,
  price,
  category,
  image,
  quickViewImage, // 追加
  isNew,
  isRecommended
}: ProductCardProps) {
  const handleProductClick = () => {
    // パフスリーブ半袖ラウンドネックトップス（id: 1）の場合は新しいリンクを使用
    if (id === 1) {
      window.open('https://shop.milan-online.jp/items/117044497', '_blank');
    } else if (id === 2) {
      window.open('https://shop.milan-online.jp/items/117043617', '_blank');
    } else if (id === 3) {
      window.open('https://shop.milan-online.jp/items/117043826', '_blank');
    } else if (id === 4) {
      window.open('https://shop.milan-online.jp/items/117043997', '_blank');
    } else if (id === 5) {
      window.open('https://shop.milan-online.jp/items/117044227', '_blank');
    } else if (id === 6) {
      window.open('https://shop.milan-online.jp/items/117044855', '_blank');
    } else if (id === 7) {
      window.open('https://shop.milan-online.jp/items/117044277', '_blank');
    } else if (id === 8) {
      window.open('https://shop.milan-online.jp/items/117043406', '_blank');
    } else if (id === 9) {
      window.open('https://shop.milan-online.jp/items/117044613', '_blank');
    } else if (id === 10) {
      window.open('https://shop.milan-online.jp/items/117043552', '_blank');
    } else if (id === 11) {
      window.open('https://shop.milan-online.jp/items/117287066', '_blank');
    } else if (id === 12) {
      window.open('https://shop.milan-online.jp/items/117043826', '_blank');
    } else if (id === 13) {
      window.open('https://shop.milan-online.jp/items/117043938', '_blank');
    } else if (id === 14) {
      window.open('https://shop.milan-online.jp/items/117043491', '_blank');
    } else {
      window.open('https://shop.milan-online.jp/items/117044497', '_blank');
    }
  };

  const handleQuickView = (e: React.MouseEvent) => {
    e.stopPropagation();
    // クイックビュー機能をここに実装
    console.log('Quick view for product:', id);
  };

  return (
    <div className="group cursor-pointer bg-white relative">
      {/* Product Image */}
      <div className="relative overflow-hidden mb-3 aspect-[3/4] bg-gray-50">
        <img
          src={image}
          alt={name}
          className="w-full h-full object-cover transition-all duration-500 group-hover:scale-105"
        />
        
        {/* Quick View Overlay with Background Image Only */}
        {quickViewImage && (
          <div 
            className="absolute inset-0 opacity-0 group-hover:opacity-100 transition-opacity duration-300"
            style={{
              backgroundImage: `url(${quickViewImage})`,
              backgroundSize: 'cover',
              backgroundPosition: 'center'
            }}
          />
        )}
        
        {/* New Badge */}
        {isNew && (
          <div className="absolute top-2 left-2 bg-black text-white px-2 py-1 text-xs font-medium tracking-wider">
            NEW
          </div>
        )}
        
        {/* Recommended Badge */}
        {isRecommended && (
          <div className="absolute top-2 right-2 bg-white text-black px-2 py-1 text-xs font-medium tracking-wider border">
            FEATURED
          </div>
        )}
      </div>
      
      {/* Product Info - Clickable */}
      <div onClick={handleProductClick} className="space-y-1">
        <h3 className="text-sm font-medium text-gray-900 leading-tight">
          {name}
        </h3>
        <p className="text-sm font-semibold text-gray-900">
          {price}
        </p>
      </div>
    </div>
  );
}
